/** @format */

import { useState } from 'react';

import ModalCustom from '../../Shared/Components/ModalCustom';
import SwitchButton from '../../Shared/Components/SwitchButton';
import { error } from '../../Shared/Components/Toast';
import { siteBaseUrl } from '../../Shared/utils/helper';
import validations from './Validation/Validation';

const EventType = ({
  loadSearchForm,
  eventContext,
  setMobile,
  formGenerate,
  setNatCode,
  setCity,
  setProvinceId,
  setCreateDate,
  errors,
  searchEventTypeTeam,
  modalAddTeam,
  setModalAddTeam,
  showTeamForm,
  setShowTeamForm,
  searchUser,
  registerInEvent,
  searchLoading,
  submitFormLoading,
  setModalRoleIsOpen,
  modalRoleIsOpen,
  setErrors,
  onSubmitEventTypeTeamForm,
  showUserRegisterForm,
  setShowUserRegisterForm,
  setTeamExistsData,
  foreigners,
  loadSwitch,
  changeForeigners,
  setForeigners,
  setNatSupervisorCode,
  removeUserInTeam,
  removeLoading,
}) => {
  const [team, setTeam] = useState({});
  // const [natCode, setNatCode] = useState('');
  // const [provinceId, setProvinceId] = useState('');
  // const [city, setCity] = useState('');

  return (
    <div className='d-flex flex-column my-2 text-dark-mode bg-dark-mode-3'>
      <form
        className='text-dark-mode bg-dark-mode-3'
        onSubmit={(e) => onSubmitEventTypeTeamForm(e)}
      >
        <div className='row mx-2'>
          {eventContext.event?.team_form?.fields?.map((item) => (
            <div
              className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'
              key={item.id}
            >
              <>
                {formGenerate(item, true)}
                {errors[item?.name] !== undefined && (
                  <span className='text-danger'>{errors[item.name]}</span>
                )}
              </>
            </div>
          ))}
        </div>
        <button className='d-none' id='submit-team-form'></button>
      </form>
      <div className='border mx-3 p-2 rounded-1'>
        <div className='row mx-2 bg-dark-mode-3'>
          <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
            <div className='form-group'>
              <button
                className='btn bg-purple text-dark-mode text-hover f-13 font-weight-bold'
                onClick={() => setShowUserRegisterForm(true)}
              >
                اضافه کردن شرکت کنندگان رویداد
              </button>
            </div>
          </div>
        </div>
        {showUserRegisterForm && (
          <form
            onSubmit={(e) => registerInEvent(e, true)}
            className='p-2 text-dark-mode my-3 bg-dark-mode-3'
          >
            <div className='row mx-2'>
              {eventContext.event?.form?.fields?.map((item) => (
                <div
                  className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'
                  key={item.id}
                >
                  <>
                    {formGenerate(item)}
                    {errors[item?.name] !== undefined && (
                      <span className='text-danger'>{errors[item.name]}</span>
                    )}
                  </>

                  {item?.foreigners !== undefined && item?.foreigners ? (
                    <div className='d-flex flex-row my-2'>
                      <label className='text-dark-mode f-14 mx-2'>
                        اتباع خارجی
                      </label>
                      {loadSwitch ? null : (
                        <SwitchButton
                          checked={
                            item?.isForeigners === undefined
                              ? false
                              : item?.isForeigners
                          }
                          onChange={(val) =>
                            changeForeigners(item.id, !item?.isForeigners)
                          }
                        />
                      )}
                    </div>
                  ) : null}
                </div>
              ))}
            </div>

            <div className='col-12'>
              <div className='d-flex flex-row justify-content-end mt-3'>
                <div className='d-flex flex-row justify-content-end '>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setShowUserRegisterForm(false);
                    }}
                    className='btn  btn bg-purple shadow-sm border text-dark-mode text-hover f-13 p-2 f-13'
                  >
                    لغو
                  </button>
                </div>
                <div className='d-flex flex-row justify-content-end mx-3'>
                  {submitFormLoading ? (
                    <div
                      className='spinner-border spinner-border-sm text-white mb-1'
                      role='status'
                    ></div>
                  ) : (
                    <button
                      type='submit'
                      className='btn  btn bg-purple shadow-sm border text-dark-mode text-hover f-13 p-2 f-13'
                    >
                      اضافه کردن
                    </button>
                  )}
                </div>
              </div>
            </div>
          </form>
        )}
        {eventContext.users?.length > 0 && (
          <div className='row my-3'>
            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 overflow-hidden '>
              {removeLoading ? null : (
                <div className='d-flex flex-column w-100 bg-purple rounded-1 overflow-auto'>
                  <table
                    className='table table-hover text-dark-mode rounded text-left overflow-auto table-hover-text'
                    dir='rtl'
                  >
                    <thead className='border-0 rounded border-bottom-dark-mode'>
                      <tr className='border-0 rounded'>
                        <th className='border-0'>نام و نام خانوادگی</th>
                        <th className='border-0'>کد ملی</th>
                        <th className='border-0'>موبایل</th>
                        <th className='border-0'>حذف</th>
                      </tr>
                    </thead>
                    <tbody>
                      {eventContext.users?.map((item) => (
                        <tr
                          className='border-bottom-dark-mode py-2'
                          key={item.id}
                        >
                          <td className='border-0'>
                            {item.first_name} {item.last_name}
                          </td>
                          <td className='border-0'>{item.nat_code} </td>
                          <td className='border-0'>{item.mobile}</td>
                          <td className='border-0'>
                            <i
                              className='fad fa-trash f-17 text-dark-mode c-pointer'
                              onClick={() => removeUserInTeam(item.id)}
                            ></i>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <div className='row mx-2 my-3 bg-dark-mode-3'>
        <div className='col-12'>
          <div className='d-flex flex-row justify-content-end'>
            <button
              onClick={(e) => {
                let validated = validations.validate(
                  eventContext.event.team_form.fields,
                  errors,
                  setErrors,
                  eventContext.event,
                );
                if (!validated) {
                  return;
                }
                if (eventContext.users?.length === 0) {
                  return error('لطفا حداقل یک شرکت کننده اضافه نمایید');
                }

                e.preventDefault();
                setModalRoleIsOpen(true);
              }}
              className='btn px-3 btn bg-purple shadow-sm border text-dark-mode text-hover f-13 p-2 f-13'
            >
              ثبت نام
            </button>
          </div>
        </div>
      </div>

      <ModalCustom modalIsOpen={modalRoleIsOpen}>
        <div className='d-flex flex-column'>
          <div className='d-flex flex-row border-bottom pb-2'>
            <i className='fad fa-warning f-20 mx-2'></i>
            <span className=''>قوانین ثبت اطلاعات</span>
          </div>

          <div className='d-flex flex-row justify-content-center'>
            <a
              target='_blank'
              className='text-dark-mode f-14 font-weight-bold text-hover d-flex mt-2'
              href={`${siteBaseUrl()}/roles/894-p.pdf`}
            >
              دریافت قوانین و دستور العمل
            </a>
          </div>
          <div className='d-flex flex-row justify-content-center my-3'>
            <button
              onClick={() => setModalRoleIsOpen(false)}
              className='btn bg-purple shadow-sm border text-dark-mode text-hover f-13'
            >
              لغو
            </button>
            <div className='d-flex flex-row justify-content-end mx-3'>
              {submitFormLoading ? (
                <div
                  className='spinner-border spinner-border-sm text-white mb-1'
                  role='status'
                ></div>
              ) : (
                <>
                  <button
                    onClick={() => {
                      let submitBnt =
                        document.getElementById('submit-team-form');
                      submitBnt.click();
                    }}
                    className='btn  btn bg-purple shadow-sm border text-dark-mode text-hover f-13 p-2 f-13'
                  >
                    قبول قوانین و ثبت نام
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </ModalCustom>
      <ModalCustom modalIsOpen={modalAddTeam}>
        <div className='d-flex flex-column'>
          <div className='d-flex flex-row border-bottom pb-2'>
            <i className='fad fa-warning f-20 mx-2'></i>
            <span className=''>تیم ها</span>
          </div>
          <div
            className='d-flex flex-column w-100 bg-purple rounded-1 overflow-auto'
            style={{ height: '250px' }}
          >
            <table
              className='table table-hover text-dark-mode rounded text-left overflow-auto table-hover-text'
              dir='rtl'
            >
              <thead className='border-0 rounded border-bottom-dark-mode'>
                {eventContext?.teams?.length > 0 ? (
                  <tr className='border-0 rounded'>
                    <th className='border-0'>انتخاب</th>

                    <th className='border-0'>نام تیم</th>
                    <th className='border-0'>استان</th>
                    <th className='border-0'>شهر</th>
                    <th className='border-0'>آدرس</th>
                  </tr>
                ) : (
                  <tr className='border-0 rounded'>
                    <th className='border-0'></th>
                  </tr>
                )}
              </thead>
              <tbody>
                {eventContext.teams?.length > 0 ? (
                  <>
                    {eventContext.teams?.map((item) => (
                      <tr
                        className='border-bottom-dark-mode py-2'
                        key={item.id}
                      >
                        <td className='border-0'>
                          <input
                            type='radio'
                            className=''
                            name='team'
                            onChange={(e) => setTeam(item)}
                          />
                        </td>

                        <td className='border-0 text-break'>
                          {item.club_name}
                        </td>
                        <td className='border-0'>{item.province?.name}</td>
                        <td className='border-0'>{item.city}</td>
                        <td className='border-0 text-break'>
                          {item.club_address}
                        </td>
                      </tr>
                    ))}
                  </>
                ) : (
                  <tr className='d-flex flex-row border-bottom-dark-mode py-2 justify-content-center'>
                    <td className='border-0 justify-content-center'>
                      اطلاعاتی جهت نمایش یافت نشد
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className='d-flex flex-row justify-content-center my-3'>
            <button
              onClick={() => setModalAddTeam(false)}
              className='btn bg-purple shadow-sm border mx-3 text-dark-mode text-hover f-13'
            >
              لغو
            </button>
            <button
              className='btn bg-purple shadow-sm border text-dark-mode text-hover f-13'
              onClick={() => setTeamExistsData(team)}
            >
              انتخاب نهایی
            </button>
            <button
              onClick={() => {
                setShowTeamForm(true);
                setModalAddTeam(false);
              }}
              className='btn bg-purple shadow-sm border text-dark-mode text-hover f-13 mx-3'
            >
              افزودن تیم جدید
            </button>
          </div>
        </div>
      </ModalCustom>
    </div>
  );
};

export default EventType;
